import Stickyfill from "stickyfilljs"

var elements = document.querySelectorAll(".sticky")
Stickyfill.add(elements)
